export const IGNORE_PARAMS = [
  'hairColor',
  'hairStyle',
  'beardColor',
  'beardStyle',
  'eyeColor',
  'eyeShape',
  'sex',
  'sexRaceType',
  'glasses',
  'raceType',
  'birthday',
  'pacifier',
  'stuffed_animal',
  'stuffedAnimal',
];
